export const ServerGetSchema = {
    id: 'id',
    pages: {
        general: {
            pageId: 'general',
            serverName: 'serverName',
            serverOS: 'serverOS',
            numOfCPUs: 'numOfCPUs',
            lastMonitorSample: 'lastMonitorSample',
            virtualMemory: 'virtualMemory',
            totalServerCpu: 'totalServerCpu',
            diskSpace: 'diskSpace',
            isCertExpNoCa: 'isCertExpNoCa',
            isCertificateError: 'isCertificateError',
            notAfter: 'notAfter',
            createTime: 'createTime',
            lastTime: 'lastTime'
        },
        settings: {
            pageId: 'settings',
            description: 'description',
            dnsEnabled: 'dnsEnabled',
            dnsAddress: 'dnsAddress',
            smpServerAddress: 'smpServerAddress',
            smpNatAddress: 'smpNatAddress',
            serverDnsName: 'serverDnsName',
            weightLogServer: 'weightLogServer',
            weightCmls: 'weightCmls'
        },
        managedModules: {
            pageId: 'managedModules',
            dataList: 'dataList',
            dataListSchema: {
                processName: 'processName',
                status: 'status',
                processMemoryUsage: 'processMemoryUsage',
                processCPUPercentage: 'processCPUPercentage',
                statusDescription: 'statusDescription'
            },
            sampleTimestamp: 'sampleTimestamp'
        }
    }
}

export const ServerGroupGetSchema = {
    id: 'id',
    pages: {
        general: {
            pageId: 'general',
            description: 'description',
            smartLogServerAddress: 'smartLogServerAddress',
            smartEventServerAddress: 'smartEventServerAddress',
            isDRMEnabled: 'isDRMEnabled'
        },
        history: {
            pageId: 'history',
            createTime: 'createTime',
            lastTime: 'lastTime'
        }
    }
}



export const ServerGroupGetListSchema = {
    name: 'name',
    servers: 'servers',
    serversSchema: {
        name: 'name',
        status: 'status',
        description: 'description',
        serverNotOkReason: 'serverNotOkReason',
        ip: 'ip',
        natIp: 'natIp',
        logServerWeight: 'logServerWeight',
        cmlsWeight: 'cmlsWeight',
        dnsName: 'dnsName',
        cpcaStatus: 'cpcaStatus',
        syslogStatus: 'syslogStatus',
        cpdStatus: 'cpdStatus',
        logServerStatus: 'logServerStatus',
        jmlsStatus: 'jmlsStatus',
        smpStatus: 'smpStatus',
        dnsStatus: 'dnsStatus',
        dnsErrorMessage: 'dnsErrorMessage'
    }
}

export const ServerStatusValues = {
    missing: 'Missing',
    ok: 'OK',
    warning: 'Warning',
    critical: 'Critical',
    disconnected: 'Disconnected'
}

export const ServerCreateSchema = {
    name: 'name',
    smsAddress: 'smsAddress',
    smpServerAddress: 'smpServerAddress',
    smpNatAddress: 'smpNatAddress',
    groupName: 'groupName'
}